export enum WoundOrderComponentTypeEnum {
  Cleanser = 1,
  Packing = 2,
  PrimaryDressing = 3,
  SecondaryDressing = 4,
  SecuringDevice = 5
}

export const WoundOrderComponentTypeOptions = [
{ id: 1, label: 'Cleanser' },
{ id: 2, label: 'Packing' },
{ id: 3, label: 'Primary Dressing' },
{ id: 4, label: 'Secondary Dressing' },
{ id: 5, label: 'Securing Device' }
];
